import * as PropTypes from 'prop-types'
import React from 'react'

import { convertAddressToString } from '../../../utils/addresses'
import s from './CompanyInfo.module.scss'

export default function CompanyInfo({ company }) {
  return (
    <div className={s['company-info']}>
      <div className={s['company-name']}>{company.name}</div>
      <div className={s.address}>{convertAddressToString(company.address)}</div>
    </div>
  )
}

CompanyInfo.propTypes = {
  company: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string,
      street: PropTypes.string,
      zipCode: PropTypes.string
    }),
    name: PropTypes.string
  }).isRequired
}
